import { gql } from 'graphql-request';

export const CACHE_UPDATE_INVOICE_CUSTOM_FIELD_QUERY = gql`
  mutation CacheUpdateInvoiceCustomField(
    $uuid: ID!
    $body: String
    $invoiceUuid: ID
    $label: String
    $location: String
    $options: Json
    $order: Int
  ) {
    updateInvoiceCustomField(
      input: {
        uuid: $uuid
        body: $body
        invoiceUuid: $invoiceUuid
        label: $label
        location: $location
        options: $options
        order: $order
      }
    ) {
      errors {
        fullMessages
      }
      record {
        body
        createdAt
        id
        invoiceId
        label
        location
        updatedAt
        userId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
